/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const SearchSkeleton = _ref => {
  let {
    small = false,
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const searchClasses = cx(className, {
    [`${prefix}--skeleton`]: true,
    [`${prefix}--search--xl`]: !small,
    [`${prefix}--search--sm`]: small
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: searchClasses
  }, rest), /*#__PURE__*/React__default.createElement("span", {
    className: `${prefix}--label`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--search-input`
  }));
};
SearchSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * Specify whether the Search should be a small variant
   */
  small: PropTypes.bool
};

export { SearchSkeleton, SearchSkeleton as default };
